import { render, staticRenderFns } from "./templates.vue?vue&type=template&id=60e91886&scoped=true"
import script from "./templates.vue?vue&type=script&lang=js"
export * from "./templates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e91886",
  null
  
)

export default component.exports